import { render, staticRenderFns } from "./AgeForm.vue?vue&type=template&id=513f87d2"
import script from "./AgeForm.vue?vue&type=script&lang=js"
export * from "./AgeForm.vue?vue&type=script&lang=js"
import style0 from "./AgeForm.vue?vue&type=style&index=0&id=513f87d2&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513f87d2')) {
      api.createRecord('513f87d2', component.options)
    } else {
      api.reload('513f87d2', component.options)
    }
    module.hot.accept("./AgeForm.vue?vue&type=template&id=513f87d2", function () {
      api.rerender('513f87d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/AgeForm.vue"
export default component.exports